module.exports = __webpack_public_path__ + "media/images/icons/twotone/interaction-a2503aedfa5a82e06c5bad2cd3a80415.svg";